import { otherApiClient } from ".";
/**
 * GNB 카테고리 메뉴 조회
 * @param homeType - 홈 타입 (teacher/student)
 * @returns 고정 3단계 구조의 카테고리 데이터
 */ export const getCategoryMenu = async (homeType)=>{
    const { data  } = await otherApiClient.market.get("/category-board", {
        params: {
            homeType
        }
    });
    return data;
};
/**
 * 시스템 카테고리 페이지 메뉴 조회
 * @param parentId - 과목 ID (10: 영어, 11: 국어, 12: 수학, 13: 과학, 14: 사회)
 * @returns 재귀적 트리 구조의 카테고리 데이터
 */ export const getSystemCategoryMenu = async (parentId)=>{
    const { data  } = await otherApiClient.market.get("/menu-categories", {
        params: {
            parentId
        }
    });
    return data;
};
